import { createActions, createReducer } from "reduxsauce";
import { updateStateGeneric } from "@redux-core/utils";
import { cloneDeep, forEach, isEmpty, set } from "@utils/lodash";
import { User } from "@components/common";

export { default as thunks } from "./thunks";

/* ------------- Initial State ------------- */
export const INITIAL_STATE = {
	user: null,
	agency: null,
	USStates: [],
	vehicleTypes: [],
	locationTypes: [],
	organizationContacts: [],
	menus: {
		subMenu: [],
	},
	active: {
		mainMenu: 0,
		subMenu: 0,
	},
	subName: "",
	modals: {
		addPaymentMethod: false,
		bankAccountVerification: false,
		payInvoice: false,
		addJurisdiction: false,
		addDirectDepositAccount: false,
	},
	loading: {
		USStates: false,
		paymentMethods: false,
		bankAccountVerificationButton: "",
		directDeposit: false,
		addDirectDepositAccountButton: "",
		vehicleTypes: false,
		locationTypes: false,
		organizationContacts: false,
		addPaymentMethod: false,
	},
	addPaymentMethodButton: "",
	paymentMethodsUser: null,
	paymentMethods: [],
	directDeposit: null,
};

/* ------------- Types and Action Creators ------------- */
export const { Types, Creators } = createActions(
	{
		receiveData: ["collection"],
		receiveUser: ["value"],
		updateUser: ["property", "value"],
		receiveAgency: ["value"],
		updateAgency: ["property", "value"],
		resetUser: null,
		resetAccount: null,
		resetMenu: ["name"],
		updateMenu: ["name", "value"],
		updateActiveLink: ["name", "value"],
		updateSubName: ["value"],
		toggleModal: ["name", "value"],
		setPaymentMethods: ["user", "value"],
		setLoading: ["name", "value"],
		setDirectDeposit: ["value"],
		getUsaStates: ["value"],
		setAdb2cState: ["value"],
	},
	{ prefix: "@app/" },
);

/* ------------- Hookup Reducers To Types ------------- */
export const reducer = createReducer(INITIAL_STATE, {
	[Types.RECEIVE_DATA]: (state, { collection }) => {
		if (!isEmpty(collection)) {
			const newState = cloneDeep(state);

			forEach(collection, ({ property, value }) => {
				set(newState, property, value);
			});

			return newState;
		}
		return state;
	},

	[Types.RESET_USER]: state => updateStateGeneric({ state, property: "user", value: null }),

	[Types.RESET_ACCOUNT]: state => ({
		...INITIAL_STATE,

		// preserve cached data
		USStates: state.USStates,
		vehicleTypes: state.vehicleTypes,
	}),

	[Types.RECEIVE_USER]: (state, { value }) => {
		const user = new User(value);
		return { ...state, user };
	},

	[Types.UPDATE_USER]: (state, { property, value }) =>
		updateStateGeneric({ state, property: `user.${property}`, value }),

	[Types.RECEIVE_AGENCY]: (state, { value }) =>
		updateStateGeneric({ state, property: "agency", value }),

	[Types.UPDATE_AGENCY]: (state, { property, value }) =>
		updateStateGeneric({ state, property: `agency.${property}`, value }),

	[Types.RESET_MENU]: (state, { name }) =>
		updateStateGeneric({ state, property: `menus.${name}`, value: [] }),

	[Types.UPDATE_MENU]: (state, { name, value }) =>
		updateStateGeneric({ state, property: `menus.${name}`, value }),

	[Types.UPDATE_ACTIVE_LINK]: (state, { name, value }) =>
		updateStateGeneric({ state, property: `active.${name}`, value }),
	[Types.UPDATE_SUB_NAME]: (state, { value }) =>
		updateStateGeneric({ state, property: "subName", value }),
	[Types.TOGGLE_MODAL]: (state, { name, value }) =>
		updateStateGeneric({ state, property: `modals.${name}`, value }),
	[Types.SET_PAYMENT_METHODS]: (state, { user, value }) => ({
		...state,
		paymentMethodsUser: user,
		paymentMethods: value,
	}),
	[Types.SET_DIRECT_DEPOSIT]: (state, { value }) =>
		updateStateGeneric({ state, property: "directDeposit", value }),

	[Types.GET_USA_STATES]: (state, { value }) =>
		updateStateGeneric({ state, property: "USStates", value }),

	[Types.SET_LOADING]: (state, { name, value }) => ({
		...state,
		loading: {
			...state.loading,
			[name]: value,
		},
	}),
});

export default Creators;
